<template>
  <RsModal
    :id="id"
    v-model="input"
    :title="title"
    :button-text="saveButtonText"
    size="lg"
    lazy
    @submit="submitData"
  >
    <VApp class="bg-white">
      <div class="row">
        <div class="col">
          <VColorPicker
            v-model="colorPicker"
            dot-size="15"
            hide-sliders
            hide-inputs
            mode="hexa"
            canvas-height="150"
          />
        </div>
        <div class="col">
          <VColorPicker
            v-model="colorPicker"
            dot-size="15"
            hide-canvas
            hide-inputs
            mode="hexa"
            canvas-height="150"
          />
          <RsFormInput
            v-model="colorPicker.hex"
            :label="hexLabel"
            type="text"
            class="pr-4"
          />
        </div>
      </div>
    </VApp>
  </RsModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface IColorPicker {
  hex: '',
}

export default defineComponent({
  name: 'RsFormColorPicker',
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    color: {
      type: Object as () => IColorPicker,
      default: () => ({ hex: '' }),
    },

    id: {
      type: String,
      default: 'id-color-picker',
    },

    title: {
      type: String,
      default: 'Background Colour',
    },

    hexLabel: {
      type: String,
      default: 'Hex',
    },

    saveButtonText: {
      type: String,
      default: 'Save',
    },
  },
  data() {
    return {
      input: this.value,
      colorPicker: { hex: '' },
    };
  },
  watch: {
    value() {
      this.input = this.value;
    },
    input() {
      this.$emit('input', this.input);
    },
    color() {
      this.colorPicker = this.color;
    },
  },
  methods: {
    submitData(): void {
      this.$emit('on-submit', this.colorPicker.hex);
    },
  },
});
</script>

<style lang="scss">
@import "@/styles/_variables";

#app.v-application {
  min-height: unset !important;
  height: 165px !important;
}

.v-color-picker__hue {
  background: linear-gradient(90deg,
  red,#ff8000,#ff0,#80ff00,
  #0f0,#00ff80,#0ff,#0080ff,
  #00f,#8000ff,#f0f,#ff0080,red);
}
.v-color-picker__alpha{
  display: none;
}
.v-color-picker__dot{
 margin-right: 12px;
 margin-bottom: 20px;
}
</style>
